import styled, { css } from 'styled-components'
import { StyledActiveProps } from './utils/StyledIcons'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem;
  background-color: 'transparent';
`

export const BoxRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin: 2rem 0 1rem 0;
`

export const Box = styled.div<{ color: string; active?: boolean }>`
  width: 7.4rem;
  height: 5.775rem;
  background: ${({ color }) => color};
  border-radius: ${(({ theme }) => theme.corners.default.borderRadius)};
  margin: 0 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: ${({
    active, theme,
  }) => (active ? `0 0 0 2px ${theme.palette.product.location.main}` : 'none')};
  position: relative;
  top: ${({ active }) => (active ? '-1rem' : '0')};
  transition: all 0.2s;
  opacity: ${({ active }) => (active ? '100%' : '40%')};
`

export const BoxLabel = styled.div<StyledActiveProps>`
  color: ${({
    isActive, theme,
  }) => (isActive ? theme.palette.light.white : theme.palette.dark.raven)};
  font-size: ${({ theme }) => theme.typography.tiny.pt_12_semibold.fontSize};
  margin-top: 0.5rem;
  font-weight: ${({ theme }) => theme.typography.main.pt_15_semibold_upper.fontWeight};
  letter-spacing: 0.3px;
`

export const ResultLabel = styled.div(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 0);
  color: ${palette.product.location.main};
  font-size: ${typography.primary.fontSize};
  font-weight: ${typography.big.pt_28_semibold.fontWeight};
  margin-top: 0.5rem;
  text-align: center;
`
})

export const Circle = styled.div(({ theme }) => {
  const { palette } = theme
  return css`
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  background: ${palette.light.white};
  display: flex;
  align-items: center;
  justify-content: center;
` })
